import React from 'react';

import { useChatBodyContext } from 'widget/content/chat/chat-body/chat-body-context';
import { useMsgContext } from '../../msg-context';
import * as Env from 'widget/env';

interface MsgButton {
  button: Env.MessageButton;
}

const MsgButton = ({ button }: MsgButton) => {
  const { sendMsg } = useChatBodyContext();
  const { msg } = useMsgContext();

  const handleClick = () =>
    sendMsg({
      content: button.body,
      file_url: '',
      quotedMsgId: msg.id,
      type: 'message',
    });

  return (
    <button className="whatcrm-widget-message__btn" onClick={handleClick}>
      {button.body}
    </button>
  );
};

export default MsgButton;
